import apiServer from '../services';
import { app } from '@/base/config.js';

const Handler = {
  getMenuTree: function (current, menus) {
    var tree = [];
    if (current.Tree) {
      var splitKeys = current.Tree.split(',');
      for (var i = 0; i < splitKeys.length; i++) {
        if (splitKeys[i] !== '') {
          var menuItem = menus.find(x => x.ElementId === splitKeys[i]);
          if (menuItem) tree.push(menuItem);
        }
      }
    }
    return tree;
  }
};

// 缓存页面权限
let CACHE_PAGER_AUTHORITY = {};
/*
 * 全局管理 （用户信息，权限信息）
 *
 */
const state = {
  test: '',
  // 个人信息
  userInfo: {
    Name: '',
    OrgId: 0,
    Account: '',
    IsAdmin: false, // 系统管理员
    OrgUserId: 0,
    Sex: '',
    OrgState: ''
  },
  // 七牛token
  uptoken: {
    token: ''
  },
  // 当前校区的信息
  currentBranch: {
    Name: '',
    OrgBranchId: -1
  },

  // 学员表单设置
  studentFormConfig: [],

  // 当前菜单
  currentMenu: [],
  // 拥有的根节点权限
  hasRoots: [],

  branchOrgList: [], // 用户校区列表

  isMinSize: false,
  currentRoot: 'NONE',
  currentMenuTree: [],
  menuList: [],
  userPrivilegeList: []
};

let getters = {
  /**
   * 返回一级菜单
   *
   */
  getParentMenuList: (state, getters) => {
    var currentRoot = state.currentRoot;
    if (currentRoot === 'NONE' && state.hasRoots.length === 0) return [];

    if (currentRoot === 'NONE') {
      currentRoot = state.hasRoots[0];
    }

    let pMenu = state.menuList
      .filter(x => x.RootElement === currentRoot && x.Level === 1)
      .map(x => {
        x.childs = getters.getMenuChilds(x.ElementId)
        return x;
      });
    if (pMenu) {
      return pMenu;
    }
    return [];
  },
  getMenuChilds: (state, getters) => elementId => {
    let menus = state.menuList
      .filter(x => x.RootElement === state.currentRoot && x.PElementId === elementId)
      .map(x => {
        x.childs = getters.getMenuChilds(x.ElementId)
        return x;
      });
    if (menus) {
      return menus;
    }
    return [];
  },
  getPagePrivilege: state => menuId => {
    let privilege = state.privilegeCache[menuId];
    if (privilege) {
      return privilege;
    }
    return [];
  },
  getCurrentRoot: state => state.currentRoot,
  // 验证是否机构菜单权限
  checkHasOrgMenu: state => state.hasRoots.some(x => x === 'org'),
  // 验证是否校区菜单权限
  checkHasBranchMenu: state => state.hasRoots.some(x => x === 'branch'),

  oneLevelMenuActive: state => {
    if (state.currentMenu && state.currentMenu.length > 1) {
      return state.currentMenu[0];
    }
    return '';
  },
  getMenuInfo: state => menuId => {
    return state.menuList.find(x => x.ElementId === menuId);
  },
  getCurrentMenu: state => state.currentMenu,
  getisMinSize: state => state.isMinSize,
  /**
   * 获取页面按钮权限
   */
  getPageAuthority: (state, getters) => (authority, pager) => {
    authority = authority.split(',');
    if (authority instanceof Array) {
      // pager = pager || getters.getCurrentMenu.slice(-1)[0];
      // var pageAuthority = (CACHE_PAGER_AUTHORITY[pager] ||
      //   ((CACHE_PAGER_AUTHORITY = {}),
      //   (CACHE_PAGER_AUTHORITY[pager] = state.userPrivilegeList.filter(
      //     x => x.PageKey === pager
      //   ))),
      // CACHE_PAGER_AUTHORITY[pager]); 
      var pageAuthority =state.userPrivilegeList;
      for (var i = 0; pageAuthority.length && i < authority.length; i++) {
        var authorityItem = authority[i];
        var bo =
        pageAuthority.findIndex(p => p.ElementId === authorityItem) > -1;
        if (bo) return !0;
      }
    }
    return !1;
  },
   /**
   * 获取页面菜单权限
   */
  getPageMenuAuthority:(state, getters) => (authority, pager) => {
    var authorityArray = authority.split(',');
    if (authorityArray instanceof Array) {
      var pageMenuAuthority =state.menuList;
      for (var i = 0; pageMenuAuthority.length && i < authorityArray.length; i++) {
        var authorityItem = authorityArray[i];
        var bo = pageMenuAuthority.findIndex(p => p.ElementId === authorityItem) > -1;
        if (bo) return !0;
      }
    }
    return !1;
  }
};

const mutations = {
  homeLoad (state, data) {
    if (state.homeReload && data === false) {
      state.homeReload = false;
    }
    state.homeReload = data;
  },
  // 设置用户权限列表
  setUserPrivilegeList (state, list) {
    state.userPrivilegeList = list;
  },

  // 设置当前校区
  setCurrentBranch (state, currentBranch) {
    if (currentBranch === undefined || currentBranch === null) {
      currentBranch = sessionStorage.getItem('currentBranch');
    }
    if (
      (currentBranch === undefined || currentBranch === null) &&
      state.branchOrgList.length > 0 &&
      state.currentRoot === 'branch'
    ) {
      currentBranch = state.branchOrgList[0];
    }
    if (currentBranch == null || currentBranch === undefined) {
      currentBranch = {
        Name: '',
        OrgBranchId: -1
      };
    }
    state.currentBranch = currentBranch;
  },

  // 设置学员表单设置
  setStudentFormConfig (state, payload) {
    state.studentFormConfig = payload;
  },
  // 设置校区列表
  setBranchOrgList (state, payload) {
    state.branchOrgList = payload;
  },

  // 设置个人信息
  setUserInfo (state, payload) {
    state.userInfo = payload;
  },
  setTest (state, payload) {
    state.Test = payload;
  },
  // 设置uptokenfr
  setUptoken (state, payload) {
    state.uptoken.token = payload;
  },
  setPrivilegeCache (state, payload) {
    sessionStorage.setItem('privilege', '');
  },
  /**
   * 数据初始化
   */
  setMenuList (state, payload) {
    let rootMenu = payload.filter(x => x.ParentId === 0);
    let hasRoots = [];
    rootMenu.forEach(x => {
      hasRoots.push(x.ElementId);
    });
    state.hasRoots = hasRoots;
    state.menuList = payload;
  },
  activeMenu (state, route) {
    if (state.menuList.length === 0 || route === undefined) {
      return;
    }
    // 获取route Name
    let name = route.name;
    let isSubPage = route.meta.isSubPage;
    let menuName = route.meta.menuName;
    let pName = route.meta.root;

    if (isSubPage) {
      name = pName;
    } else {
      state.currentMenuTree = [];
    }

    // 根据三级菜单获取菜单树
    let currentMenu = state.menuList.find(x => {
      return x.ElementId === name;
    });
    if (currentMenu === undefined) {
      // 用户没有权限
      // TODO: 强制跳转 无权限页
      return !0;
    }
    if (isSubPage) {
      // 子页面头部菜单
      var menuTree = Handler.getMenuTree(currentMenu, state.menuList);
      if (menuName) {
        menuTree.push(menuName);
      }
      state.currentMenuTree = menuTree;
    }
    state.currentRoot = currentMenu.RootElement;
    // 获取菜单
    let menus = [];
    currentMenu.Tree.split(',').forEach(i => {
      if (i.length > 0) menus.push(i);
    });
    state.currentMenu = menus;
    // 校区管理员登录时重新获取它的当前校区信息
    _getBranchInfo(state);
  },
  changeRoot (state, obj) {
    state.currentRoot = obj.root;

    let currentBranch;
    if (obj.root === 'branch') {
      currentBranch = {
        Name: obj.branchName,
        OrgBranchId: obj.branchId
      };
    } else {
      currentBranch = {
        Name: '',
        OrgBranchId: -1
      };
    }

    state.currentBranch = currentBranch;
    sessionStorage.setItem('currentBranch', JSON.stringify(currentBranch));

    if (typeof obj.callback === 'function') obj.callback();
  },
  // 设置菜单是否是缩进
  setisMinSize (state, payload) {
    state.isMinSize = payload;
  }
};

function _userInfoCallBack (context, res) {
  let menuData = res.MenuList;

  let userInfo = {
    Name: res.Name,
    OrgId: res.OrgId,
    Account: res.Account,
    IsAdmin: res.IsAdmin,
    IsShowUserGuide: res.IsShowUserGuide,
    OrgUserId: res.OrgUserId,
    Sex: res.Sex,
    State: res.State
  };

  let branchList = res.OrgBranchParamList;
  let privilegeList = res.PrivilegeList;
  let shortcutEntryPrivilege = privilegeList.filter(x => x.Category === 'shortcutEntry');
  shortcutEntryPrivilege.forEach(i => {
    let index = i;
    let selectitem = index.ElementId !== 'shortcutEntry' ? menuData.findIndex(x => x.ElementId === index.RelationElementId) : 0;
    if (selectitem === -1) {
      privilegeList.splice(privilegeList.findIndex(x => x.ElementId === index.ElementId), 1);
    }
  })
  let temp = {
    menuData,
    userInfo,
    branchList,
    privilegeList
  };

  _userInfoCommit(context, temp);
  sessionStorage.setItem('userInfo', JSON.stringify(temp));
}

function _userInfoCommit (context, data) {
  context.commit('setMenuList', data.menuData);
  context.commit('setUserInfo', data.userInfo);
  context.commit('setBranchOrgList', data.branchList);
  context.commit('setUserPrivilegeList', data.privilegeList);
}
function _getBranchInfo (state) {
  let currentBranch = sessionStorage.getItem('currentBranch');
  if (!currentBranch) {
    if (
      state.currentRoot === 'branch' &&
      state.currentBranch.OrgBranchId === -1 &&
      state.branchOrgList.length > 0
    ) {
      state.currentBranch.Name = state.branchOrgList[0].Name;
      state.currentBranch.OrgBranchId = state.branchOrgList[0].OrgBranchId;
    }
  }
}

const actions = {
  /**
   * TODO: 这个配置走cookie
   */
  setMinSize (context, payload) {
    let isMinSize = true;
    if (payload) isMinSize = payload.isMinSize;
    app.cookieUtil._setCookie('Org_isMinSize', isMinSize, 7);
    context.commit('setisMinSize', isMinSize);
  },

  /**
   * 获取用户信息
   */
  getUserInfo (context, payload) {
    let type = 'defalut';
    if (payload) type = payload.type;
    let userInfo = sessionStorage.getItem('userInfo');
    if (type !== 'login' && userInfo && userInfo != null) {
      _userInfoCommit(context, JSON.parse(userInfo));
      let isMinSize = false;
      isMinSize = app.cookieUtil._getCookie('Org_isMinSize');

      context.commit('setisMinSize', isMinSize === 'true');
      if (payload && typeof payload.callback === 'function') {
        payload.callback();
      }
    } else {
      apiServer.sys._getUserInfoLogin({
        type: 'org,branch,shortcutEntry'
      }).then(res => {
        _userInfoCallBack(context, res);
        if (payload && typeof payload.callback === 'function') {
          payload.callback();
        }
      });
    }
    let currentBranch = sessionStorage.getItem('currentBranch');
    if (currentBranch !== undefined && currentBranch !== '') {
      context.commit('setCurrentBranch', JSON.parse(currentBranch));
    }
  },

  // 获取权限列表
  getPrivilege (context, payload) {
    apiServer.sys._getCurrentUserPrivilegeList().then(res => {
      context.commit('setUserPrivilegeList', res);
    });
  },

  // 获取图片uptoken
  getUptoken (context, payload) {
    return apiServer.common._getQiniuToken().then(res => {
      context.commit('setUptoken', res.uptoken);
    });
  },

  removeUserInfo (context, payload) {
    context.commit('setCurrentBranch', {
      Name: '',
      OrgBranchId: -1
    });
    window.apollo = null;
    CACHE_PAGER_AUTHORITY = {};
    sessionStorage.removeItem('userInfo');
    sessionStorage.removeItem('currentBranch');
    app.cookieUtil._clearCookie('Org_Remember_Password');

    if (payload && payload.type === 'reload') {
      context.dispatch('getUserInfo');
    } else {
      app.tokenUtil.clearTokenData();
    }
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/global.js